import React from 'react'
import {
  PictureProgress,
  NumberComponent,
  PointerProgressComponent,
  IconComponent,
  ProgressComponent,
  JumpHotAreaComponent,
  NumberComponentWithRect
} from '../../components'

const componentMap = (hasRectArea) => ({
  current: hasRectArea ? NumberComponentWithRect : NumberComponent,
  target: hasRectArea ? NumberComponentWithRect : NumberComponent,
  pointer_progress: PointerProgressComponent,
  icon: IconComponent,
  progress: ProgressComponent,
  image_progress: PictureProgress,
  jumpable: JumpHotAreaComponent
})

class Step extends React.Component {
  static renderLayer = ({ childKey, hasRectArea, ...restArgs }) => {
    const Component = componentMap(hasRectArea)[childKey]
    if (Component && Component.renderLayer) {
      Component.renderLayer({ childKey, ...restArgs })
    }
  }

  static removeLayer = ({ childKey, hasRectArea, ...restArgs }) => {
    const Component = componentMap(hasRectArea)[childKey]

    if (Component && Component.removeLayer) {
      Component.removeLayer({ childKey, ...restArgs })
    }
  }

  render() {
    const { childKey, propMap = {} } = this.props
    const prop = propMap[childKey] || {}
    const { hasRectArea } = prop
    const Component = componentMap(hasRectArea)[childKey]
    const NumComponent = hasRectArea ? NumberComponentWithRect : NumberComponent
    const allProps = { ...this.props, ...prop }

    if (childKey === 'current' || childKey === 'target') {
      return (
        <div className="control-container">
          <NumComponent {...allProps} hiddenCombin />
        </div>
      )
    }
    return <div className="control-container">{Component && <Component {...allProps} />}</div>
  }
}

export default Step
